module.exports = __webpack_public_path__ + "img/1.2753b481.jpeg";